module.exports = __webpack_public_path__ + "img/S2.4b2b28b2.jpg";